/* eslint-disable no-return-assign */
import { Button, Spin } from 'antd';
import React, { FC, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styles/styled-components';
import { ApplicationRootState } from 'types';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { Viewport } from 'components/ViewportProvider';
import { selectBuyer } from 'containers/MainLayout/selectors';
import { Buyer, SubmitKeepInTouchFormRequest } from 'types/schema';
import media from 'utils/mediaStyle';
import Benefits from '../FarmToTablePage/components/Benefits';
import OurCustomers from '../FarmToTablePage/components/OurCustomers';
import { contactUs } from './actions';

import { FormattedMessage } from 'react-intl';
import WhyChooseUsSection from '../FarmToTablePage/components/BenefitsCollapse';
import { SectionTitle, SectionTitleBox } from '../FarmToTablePage/components/Partners';
import ContactUsForm from './ContactUsForm';
import GrowTogetherImage from './grow-together.png';
import KeepInTouchImage from './keep-in-touch.png';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import selectFarmToTablePage from './selectors';
import { ContainerState } from './types';
import { commonDimensions } from 'utils/constants';

// import { FormattedMessage } from 'react-intl';

const Spinner = styled(Spin)`
  top: calc(100vh / 2) !important;
  transform: translateY(-50%) !important;
`;

const Container = styled.div`
  position: relative;
  background: #ffffff;
  margin-top: 100px;
  ${media.md`
  margin-top: 106px;
  }
  `}
`;

const ContactSection = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto 35px;
  padding: 48px 16px 0px;
  flex-direction: column-reverse;
  align-items: center;
  gap: 40px;
  ${media.lg`
    flex-direction: row;
    gap: 0px;
    margin: 0 auto 30px;
  }
  `}
`;

const LearnMoreOurService = styled.div`
  flex-grow: 1;
  max-width: 538px;
`;

const LearnMoreOurServiceImage = styled.div`
  background-image: url(${KeepInTouchImage});
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  padding-top: 80%;
`;

const ContactTitleBox = styled.div`
  margin-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContactSubTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #585a60;
  text-align: center;
`;

const SectionTitleBoxWrapper = styled.div`
  margin-bottom: 8px;
`;

const ButtonContact = styled(Button)`
  height: 40px;
  padding: 12px;
  border-radius: 8px;
  color: #43a047;
  border-color: #43a047;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  background: transparent;
  margin-top: 24px;
  display: flex;
  align-items: center;
  &:hover {
    background: #f0f9f1 !important;
  }
  &:active {
    border-color: #3c9041 !important;
    color: #3c9041 !important;
  }
  ${media.md`
    font-size: 16px;
    `}
`;

const GrowTogetherContainer = styled.div`
  background: #f0f9f1;
  padding: 75px 0px 80px;
  margin-bottom: -20px;
  @media (max-width: 991px) {
    padding: 8px 16px 50px;
  }
`;

const GrowTogether = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  margin: 0 auto;
`;

const GrowTogetherImageElement = styled.div`
  background-image: url(${GrowTogetherImage});
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  width: 100%;
  padding-top: 32.7%;
  border-radius: 16px;
`;

const TrustedIndexWrapper = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 24px;
  flex-wrap: wrap;
`;

const TrustedIndexEl = styled.div`
  background: #ffffff;
  padding: 40px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  ${media.md`
   flex: 1;
  `}
`;

const TrustedIndexValue = styled.span`
  color: #3c9041;
  font-size: 22px;
  font-weight: 500;
  line-height: 30px;
  ${media.md`
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
  `}
`;

const TrustedIndexLabel = styled.span`
  color: #2F382C
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  ${media.md`
    font-size: 16px;
    line-height: 20px;
  `}
`;

export interface IStateProps {
  farmToTable: ContainerState;
  buyer: Buyer;
}

interface IDispatchProps {
  onSubmit: (data: { values: SubmitKeepInTouchFormRequest; cb: (res: any) => void }) => void;
}

type Props = IStateProps & IDispatchProps & RouteComponentProps;

const KeepInTouchPage: FC<Props> = (props) => {
  const { history, onSubmit } = props;
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = !!localStorage.getItem('token');
  const growTogetherData = useMemo(() => {
    return [
      {
        id: 1,
        value: '+4000',
        label: lang === 'vi' ? 'Mã sản phẩm đa dạng' : 'Diverse Product SKUs',
      },
      {
        id: 2,
        value: '+4000',
        label: lang === 'vi' ? 'Doanh nghiệp tin dùng' : 'Trusted Business',
      },
      {
        id: 3,
        value: '50K+',
        label: lang === 'vi' ? 'Đơn hàng mỗi tháng' : 'Monthly Orders',
      },
      {
        id: 4,
        value: '99.8%',
        label: lang === 'vi' ? 'Giao hàng đúng lúc' : 'On-Time Delivery',
      },
    ];
  }, [lang]);

  return (
    <Fragment>
      <Spinner spinning={false}>
        <Container>
          <Viewport.Consumer>
            {({ width }) => {
              const isMobile = width <= 576;
              return (
                <>
                  <ContactSection>
                    <LearnMoreOurService>
                      <LearnMoreOurServiceImage />
                      {!loggedIn && (
                        <ContactTitleBox>
                          <SectionTitleBoxWrapper>
                            {lang === 'vi' ? (
                              <>
                                <SectionTitle>
                                  Tìm hiểu thêm về&nbsp;
                                  <SectionTitle highLight>dịch vụ?</SectionTitle>
                                </SectionTitle>
                              </>
                            ) : (
                              <>
                                <SectionTitle>
                                  Want to&nbsp;
                                  <SectionTitle highLight>know more?</SectionTitle>
                                </SectionTitle>
                              </>
                            )}
                          </SectionTitleBoxWrapper>
                          <ContactSubTitle>
                            <FormattedMessage {...messages.subTitle} />
                          </ContactSubTitle>
                          <ButtonContact onClick={() => history.push('/contact-us')}>
                            <FormattedMessage {...messages.contactToSale} />
                          </ButtonContact>
                        </ContactTitleBox>
                      )}
                    </LearnMoreOurService>
                    <ContactUsForm submitting={false} onSubmit={onSubmit} />
                  </ContactSection>
                  {width > 1200 ? (
                    <WhyChooseUsSection
                      customHeader={
                        <SectionTitleBox>
                          {lang === 'vi' ? (
                            <>
                              <SectionTitle>
                                Vì sao nên chọn&nbsp;
                                <SectionTitle highLight>Kamereo?</SectionTitle>
                              </SectionTitle>
                            </>
                          ) : (
                            <>
                              <SectionTitle>
                                Why you should choose&nbsp;
                                <SectionTitle highLight>Kamereo?</SectionTitle>
                              </SectionTitle>
                            </>
                          )}
                        </SectionTitleBox>
                      }
                    />
                  ) : (
                    <Benefits
                      customHeader={
                        <SectionTitleBox>
                          {lang === 'vi' ? (
                            <>
                              <SectionTitle>Vì sao nên chọn&nbsp;</SectionTitle>
                              <SectionTitle highLight>Kamereo?</SectionTitle>
                            </>
                          ) : (
                            <>
                              <SectionTitle highLight>Why you should choose&nbsp;</SectionTitle>
                              <SectionTitle>Kamereo?</SectionTitle>
                            </>
                          )}
                        </SectionTitleBox>
                      }
                    />
                  )}
                  <OurCustomers whiteBackground={true} />
                  <GrowTogetherContainer>
                    <GrowTogether>
                      <SectionTitleBox>
                        {lang === 'vi' ? (
                          <>
                            <SectionTitle>
                              Cùng nhau&nbsp;
                              <SectionTitle highLight>phát triển mạnh hơn</SectionTitle>
                            </SectionTitle>
                          </>
                        ) : (
                          <>
                            <SectionTitle>
                              Growing&nbsp;
                              <SectionTitle highLight>Strong Together</SectionTitle>
                            </SectionTitle>
                          </>
                        )}
                      </SectionTitleBox>
                      <GrowTogetherImageElement />
                      <TrustedIndexWrapper>
                        {growTogetherData.map((growTogether) => (
                          <TrustedIndexEl key={growTogether.id}>
                            <TrustedIndexValue>{growTogether.value}</TrustedIndexValue>
                            <TrustedIndexLabel>{growTogether.label}</TrustedIndexLabel>
                          </TrustedIndexEl>
                        ))}
                      </TrustedIndexWrapper>
                    </GrowTogether>
                  </GrowTogetherContainer>
                </>
              );
            }}
          </Viewport.Consumer>
        </Container>
      </Spinner>
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  farmToTable: selectFarmToTablePage(),
  buyer: selectBuyer(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onSubmit: (data: { values: SubmitKeepInTouchFormRequest; cb: (res: any) => void }) =>
    dispatch(contactUs.request(data)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({
  key: 'keepInTouch',
  reducer: reducer,
});

const withSaga = injectSaga({ key: 'keepInTouch', saga: saga });

export default compose(withConnect, withReducer, withSaga, withRouter)(KeepInTouchPage);
